import router from "@/router/index.js";
// import NProgress from 'nprogress'
// import 'nprogress/nprogress.css'
import { Message } from "element-ui";
import { getlocalStorage } from "@/utils/auth";
const whileList = ["/login"];
console.log(router);
const token = localStorage.getItem("token");
// console.log(token);
const time = Date.now() - window.localStorage.getItem("TOKEN_TIME");
router.beforeEach(async (to, from, next) => {
  // NProgress.start()
  if (to.path === "/login") return next();
  if (token) {
    // token是否过期
    // console.log(time);
    // if (time > 86400000) {
    //   Message({
    //     message: '请重新登录',
    //     type:'info'
    //   })
    //   window.localStorage.clear()
    //   return next('/login')
    // }
    // console.log(to.meta.title);
    if (to.meta.title) {
      document.title = to.meta.title|| '云上世界';
    }
    // 每次路由跳转让页面回到顶部
    document.documentElement.scrollTop = 0;
    next();
  } else {
    // alert('请登录!')
    // next('/login')
    next();
  }
});

router.afterEach(() => {
  // NProgress.done()
});



//////////////////
// WEBPACK FOOTER
// ./src/permission.js
// module id = null
// module chunks = 